"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ALL_COLUMNS = void 0;
var ALL_COLUMNS = 'all_columns';
exports.ALL_COLUMNS = ALL_COLUMNS;